(ns frontend.test.kanban-v2.kanban-v2-rf
  (:require
   [frontend.test.kanban-v2.events :as events]
   [frontend.test.kanban-v2.subs]
   [frontend.ux-overhaul.kanban.view :as kanban]
   [re-frame.core :as rf]))


(defn view
  [{:keys [route-params]}]
  (let [items (rf/subscribe [:kanban/items])
        view-settings (rf/subscribe [:kanban/view-settings])
        card-settings (rf/subscribe [:kanban/card-settings])
        group-by-attribute (rf/subscribe [:kanban/group-by-attribute])
        all-items-map (rf/subscribe [:kanban/all-items-map])
        column-labels (rf/subscribe [:kanban/column-labels])
        column-contents (rf/subscribe [:kanban/column-contents])
        items-state (rf/subscribe [:kanban/items-state])
        kanban-data {:column-labels (:column-labels @items-state)
                     :columns       (:column-contents @items-state)}]
    (js/console.log "ITEMS : " @items
                    "\n" @column-contents)
    (fn []
      [:div
       {:class "bg-base-light h-screen"}
       [:div
        {:class "border border-solid border-base-light-border-paler"}
        (count @items)]
       [:div
        {:class "border border-solid border-base-light-border-paler"}
        (str @group-by-attribute)]
       [kanban/view
        {:card-renderer    (fn [args]
                             [:div {:style {:padding "20px 20px 0px 20px"}}
                              [kanban/kanban-card args card-settings]])

         :column-renderer  (partial kanban/default-column-renderer {:data kanban-data})

         :column-count     (-> kanban-data
                               :column-labels
                               count)
         :data             kanban-data
         :background-color "white"
         :group-by-attr    @group-by-attribute
         ;:set-group-by-attr recalculate-order
         ;:items-state      items-state
         :board-height     800
         :board-width      1500
         :column-width     280
         :column-gap       10
         :on-drag-end      (fn [{:keys [item-id source-col-index target-col-index]}]
                             (js/console.log "drag end")
                             (js/console.log "item id " item-id)
                             (js/console.log "source-col-index " source-col-index)
                             (js/console.log "target-col index " target-col-index))}]])))

(defn test-data
  []
  @(rf/subscribe [:app-db])
  @(rf/subscribe [:kanban/view-settings])
  @(rf/subscribe [:kanban/card-settings])
  @(rf/subscribe [:kanban/group-by-attribute])
  @(rf/subscribe [:kanban/all-items-map])
  @(rf/subscribe [:kanban/column-labels])
  @(rf/subscribe [:kanban/column-contents])
  @(rf/subscribe [:kanban/items-state])

  (rf/dispatch [::events/reset-kanban-db
                {:itens-n 7
                 :group-by-attribute :country}])
  #_(rf/dispatch [::events/reset-kanban-db
                  {:itens-n 2
                   :group-by-attribute :tag}])
)
